module.exports = __webpack_public_path__ + "static/media/drone-contract-hubita.b119c0da.gif";